import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"
import GridContainer from "@/components/common/GridContainer"
import { getCssSizeValue, getMapKey } from "@/utils/utils"
import Tile from "@/components/TilesModule/variants/TilesContactCards/Tile"
import styled from "styled-components"

const TilesContainer = styled(GridContainer)`
	padding-top: ${getCssSizeValue(40)};
`

export default function TilesContactCards({ data, paddings, headerDescription }) {
	const id = data?.id || ""
	const tiles = data?.tiles || []

	return (
		<section id={id} className={paddings}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			<TilesContainer>
				{tiles.map((tile, index) => {
					return <Tile key={getMapKey(tile, index)} tile={tile} />
				})}
			</TilesContainer>
		</section>
	)
}
